import { render } from "./PixPaymentView.vue?vue&type=template&id=30d73658"
import script from "./PixPaymentView.vue?vue&type=script&lang=js"
export * from "./PixPaymentView.vue?vue&type=script&lang=js"

import "./PixPaymentView.vue?vue&type=style&index=0&id=30d73658&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__